/**
 * Checks if a given string is a valid JSON representation of an object or array.
 *
 * Unlike a general JSON validator, this function excludes primitive values
 * such as numbers, booleans, strings, and `null`. Only objects (`{}`) and
 * arrays (`[]`) are considered valid.
 *
 * @param {unknown} input - The value to test, expected to be a string.
 * @returns {boolean} True if the input is a string that can be parsed into
 *                    a non-null object or array, otherwise false.
 */
export function isJSON(input: unknown): boolean {
  if (typeof input !== 'string') {
    return false;
  }

  try {
    const parsed = JSON.parse(input);
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }
}
